import React from 'react'

import API from 'common/src/api'

class LocationEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      radius:      this.props.radius,
      suburbId:    this.props.suburb.id,
      suburbName:  this.props.suburb.name,
      lat:         this.props.suburb.lat,
      lng:         this.props.suburb.lng
    }
    this.handleRadiusChange = this.handleRadiusChange.bind(this)
    this.handleAutocompleteSelection = this.handleAutocompleteSelection.bind(this)
    this.handleLocationChange = this.handleLocationChange.bind(this)
  }

  componentDidMount() {
    this.initializeMap()

    if (!this.props.mapOnly) {
      this.onAutocomplete()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      this.setState({
        radius: nextProps.radius,
        suburbId: nextProps.suburb.id,
        suburbName: nextProps.suburb.value,
        lat: nextProps.suburb.lat,
        lng: nextProps.suburb.lng
      }, function() {
        this.setMapChanges()
      })
    }
  }

  handleRadiusChange(event) {
    this.setState({
      radius: event.target.value
    }, function() {
      this.setCircleRadius()
      this.setMapZoom()
      this.props.handleComponentUpdate()
      $('#coverage-filter').trigger('job-filter.save');
    })
  }

  handleLocationChange(event) {
    this.setState({
      suburbId: ''
    })
  }

  handleAutocompleteSelection(event, response) {
    let suburb = response.item

    this.setState({
      suburbId: suburb.id,
      suburbName: suburb.name,
      lat: suburb.lat,
      lng: suburb.lng
    }, function() {
      this.setMapCenter()
      this.setMarkerPosition()
      this.props.handleComponentUpdate()
      $('#coverage-filter').trigger('job-filter.save');
    })
  }

  initializeMap() {
    let mapBox = document.querySelector("#map-box")
    let mapStyles = [ { featureType: 'road',     stylers: [{ visibility: 'off' }]},
                      { featureType: 'poi.park', stylers: [{ visibility: 'simplified' }]},
                      { featureType: 'transit',  stylers: [{ visibility: 'off' }]} ]
    let ausCenter = this.createLatLng(-23.6288140, 134.29759820)

    this.map = new window.google.maps.Map(mapBox, {
      visualRefresh: true,
      center: ausCenter,
      mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      gestureHandling: 'cooperative',
      panControl: false,
      scrollwheel: false,
      zoomControl: true,
      zoomControlOptions: { style:    window.google.maps.ZoomControlStyle.LARGE,
                            position: window.google.maps.ControlPosition.LEFT_CENTER },
      disableDoubleClickZoom: true,
      scaleControl: true,
      scaleControlOptions: { position: window.google.maps.ControlPosition.RIGHT_BOTTOM },
      streetViewControl: false,
      draggable: false
    })

    this.map.setOptions({ styles: mapStyles })

    this.marker = new window.google.maps.Marker({
      map: this.map,
      position: ausCenter
    })

    this.circle = new window.google.maps.Circle({
      map: this.map
    })
    this.circle.bindTo('center', this.marker, 'position')

    this.setMapCenter()
    this.setMapZoom()
    this.setMarkerPosition()
    this.setCircleRadius()
  }

  setMapChanges() {
    this.setCircleRadius()
    this.setMapZoom()
    this.setMapCenter()
    this.setMarkerPosition()
  }

  setMapCenter() {
    let mapCenter
    if (this.state.lat && this.state.lng) {
      mapCenter = this.createLatLng(this.state.lat, this.state.lng)
    }
    this.map.setCenter(mapCenter)
  }

  setMarkerPosition() {
    this.marker.setPosition(this.createLatLng(this.state.lat, this.state.lng))
  }

  setCircleRadius() {
    this.circle.setRadius(this.state.radius * 1000)
  }

  onAutocomplete() {
    $('#location').autocomplete({
      source: function (request, cb) {
        $.ajax(API.V3.suburbsGet({ 'filter[q]': request.term }))
        .done(function(response) {
          let results = response.data.map( item => ({ value: item.attributes.fullName,
                                                      id : parseInt(item.id, 10),
                                                      lat: item.attributes.lat,
                                                      lng: item.attributes.lng })
                                         )
          cb(results)
        })
        .fail(function() {
          document.location = "/500";
        })
      },
      select: this.handleAutocompleteSelection,
      autoFocus: true
    })
  }

  createLatLng(lat, lng) {
    return new window.google.maps.LatLng(lat, lng)
  }

  setMapZoom() {
    let d = this.state.radius
    let zoom = d > 2800 ? 2 : d > 1250 ? 3 : d > 650 ? 4 : d > 330 ? 5 : d > 170 ? 6 : d > 85 ? 7 : d > 45 ? 8 : d > 21 ? 9 : d > 11 ? 10 : d > 5 ? 11 : d > 2 ? 12 : d > 1.5 ? 13 : d > 0.75 ? 14 : d > 0.38 ? 15 : d > 0.19 ? 16 : d > 0.09 ? 17 : d > 0.03 ? 18 : d > 0.02 ? 19 : d > 0.01 ? 20 : 10;
    this.map.setZoom(zoom)
  }

  render() {
    if (this.props.mapOnly) {
      return (
        <div id='map-area' className='relative'>
          <div className='row'>
            <div className='col-xs-12'>
              <div id='map-container'>
                <div id='map-box'></div>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div id='map-area' className='relative'>
          <div className='form-group'>
            <div className='row mb16'>
              <div className="col-xs-12">
                <div className="card card-flat sm-ml16 sm-mr16 pl16 pr16 sm-pl0 sm-pr0">
                  <div className="card-content card-pad-md">
                    <div className="font-21 bold">You are looking for work within
                    </div>
                    <div className="row">
                      <div className="col-xs-12 col-sm-4">
                        <input type='text'
                          autoFocus
                          className='p8 mt16 mr8 mb16 form-control sm-mb0'
                          name='radius'
                          value={this.state.radius}
                          onChange={this.handleRadiusChange}
                          id='radius'
                          size='40'
                        />
                      </div>
                      <div className="col-xs-12 col-sm-2 sm-p0 sm-mt32" style={{width: '120px'}}>
                        <span className="font-14 bold">kilometers of</span>
                      </div>
                      <div className="col-xs-12 col-sm-4 sm-pl0">
                        <input type='text'
                          id='location'
                          className='p8 mt16 form-control ml0'
                          name='location'
                          defaultValue={this.state.suburbName}
                          onChange={this.handleLocationChange}
                          size='40'
                        />
                        <input type='hidden'
                          name='suburb_id'
                          value={this.state.suburbId}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div id='map-container'>
                  <div id='map-box' className='sm-ml16 ml0'></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default LocationEditor
